<template>
  <div :class="`popup popup_wizard card-upload-popup d-print-none ${isOpen ? 'opened' : ''}`">
    <div :class="`popup-data ${isOpen ? 'opened' : ''}`">
      <div class="popup-header" v-text="title"/>

      <div class="popup-inner">
        <template v-if="step === 1">

          <div class="popup-content">
            <div class="bg-warning-light pt-3 px-3 pb-1 rounded">
              <p v-text="subtitle" class="color-hint mb-0 font-weight-bold"/>
              <code-hint :code-text-hint="text" />
            </div>

            <h6 class="mt-4" v-text="scanHeader"/>
            <div class="rounded border-dashed image-container">
              <div v-if="image && image.url" class="my-3 d-flex flex-column justify-content-center align-items-center">
                <img
                  :src="image.url"
                  class="mb-2"
                  alt=""
                />
                <button class="btn btn-sm btn-light" @click.prevent="removeImage">Remove</button>
              </div>
              <template v-else>
                <div class="wizard-upload__wrapper rounded">
                  <input type="file"
                         ref="uploadInput"
                         accept="image/*"
                         capture="environment"
                         class="wizard-upload__input"
                         @change.prevent="uploadImage">
                  <span class="text-primary wizard-upload__button rounded cursor-pointer"
                        role="button"
                        @click="onClickOnFile">
                    <span v-text="scanHint" class="font-weight-bold"/>
                  </span>
                </div>
              </template>
            </div>
          </div>

          <div class="popup-actions pt-3 pb-1 d-flex justify-content-end align-items-center">
            <button
              v-text="cancel"
              class="btn btn-outline-primary mr-3"
              @click.prevent="closeModal"
            />
            <button
              v-text="scanButton"
              class="btn btn-primary"
              :disabled="isUploadDisabled"
              @click.prevent="sendImage"
            />
          </div>
        </template>

        <template v-else-if="step === 2">
          <div class="popup-content d-flex flex-column justify-content-center align-items-center">
            <Loader :text="progressHint"/>
          </div>

          <div class="popup-actions pt-3 pb-1 d-flex justify-content-end align-items-center">
            <button
              v-text="cancel"
              class="btn btn-outline-primary mr-3"
              @click.prevent="closeModal"
            />
          </div>
        </template>

        <template v-else-if="step === 3">
          <div class="popup-content">
            <choose-type
              :workflow-details="workflowDetails"
              v-model="nonSpecifiedCodes"
              :cancel="cancel"

              @save="updateCodes"
              @cancel="closeModal"
            />
          </div>
        </template>

        <template v-else-if="step === 4">
          <!-- success/failure -->
          <div class="popup-content d-flex flex-column align-items-center justify-content-center px-5">
            <template v-if="success">
              <h3 v-text="successTitle"/>

              <template v-if="isSumBased || (codes.length === 1)">
                <p class="mb-0" v-text="successText"/>
                <div class="d-flex flex-column align-items-center justify-content-center">
                  <template v-for="code in codes">
                    <Code :value="code.value" class="my-2"/>
                  </template>
                </div>
              </template>
              <template v-else>
                <p class="mb-0">There are more then one code is recognized. Please choose one which you would like to use</p>
                <div class="d-flex flex-column align-items-center justify-content-center">
                  <template v-for="code in codes">
                    <label class="d-flex flex-row align-items-center p-1">
                      <span class="mr-2">
                        <input
                          type="radio"
                          name="primaryCode"
                          :id="`code_${code}`"
                          :value="code"
                          class="workflow-radio"
                          v-model="primaryCode"/>
                        <span/>
                      </span>
                      <Code :value="code.value" class="my-2"/>
                    </label>
                  </template>
                </div>
              </template>
            </template>
            <template v-else>
              <h3 v-text="failureTitle"/>
              <p class="mb-0 text-center" v-text="errorMessage || failureText"/>
            </template>
          </div>

          <div class="popup-actions pt-3 pb-1 d-flex justify-content-end align-items-center">
            <template v-if="success">
              <button
                v-text="cancel"
                class="btn btn-outline-primary mr-3"
                @click.prevent="closeModal"
              />
              <button
                v-text="successButton"
                class="btn btn-primary"
                @click.prevent="saveCodes"
              />
            </template>
            <template v-else>
              <button
                v-text="enterManually"
                class="btn btn-outline-primary mr-3"
                @click.prevent="closeModal"
              />
              <button
                v-text="scanButton"
                class="btn btn-primary"
                @click.prevent="goToBegin"
              />
            </template>
          </div>
        </template>
      </div>

      <a href="#" class="popup-close" @click.prevent="closeModal">×</a>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { uniq } from "lodash";

import { Statuses } from "../../ocrComponent/Statuses.model";
import Loader from "./Loader.vue";
import ChooseType from "./chooseType.vue";
import Code from "./code.vue";
import CodeHint from '../../ocrComponent/Hint.vue';

export default {
  components: { Code, ChooseType, Loader, CodeHint },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    text: { type: String, required: true },
    scanHeader: { type: String, required: true },
    scanHint: { type: String, required: true },
    scanButton: { type: String, required: true },
    progressHint: { type: String, required: true },
    enterManually: { type: String, required: true },
    cancel: { type: String, required: true },
    failureTitle: { type: String, required: true },
    failureText: { type: String, required: true },
    successTitle: { type: String, required: true },
    successText: { type: String, required: true },
    successButton: { type: String, required: true },
    workflowTitle: { type: String, required: true },

    uniqueCodesError: { type: String, required: true },
    maxSizeError: { type: String, required: true },
    readerError: { type: String, required: true },
    verifyCodesError: { type: String, required: true },

    physicalFlowImageTitle: { type: String, required: true },
    physicalFlowImage: { type: String, required: true },
    physicalFlowImageDescription: { type: String, required: true },
    digitalFlowImageTitle: { type: String, required: true },
    digitalFlowImage: { type: String, required: true },
    digitalFlowImageDescription: { type: String, required: true },

    detectTextEndpoint: { type: String, required: true },
    sseEndpoint: { type: String, required: true },
    workflowTypeDetectionEndpoint: { type: String, required: true },
  },

  data() {
    return {
      fileSizeLimit: 8, // Mb

      step: 1,

      success: false,
      errorMessage: null,
      loading: false,

      isOpen: false,

      image: null,

      codes: [],
      primaryCode: null,

      isSumBased: false,
    }
  },

  mounted() {
    this.reader = new FileReader();

    this.$eventBus.$on('open:upload-modal', this.openModal);
    this.$eventBus.$on('close:upload-modal', this.closeModal);
  },

  beforeDestroy() {
    this.$eventBus.$off('open:upload-modal');
    this.$eventBus.$off('close:upload-modal');
  },

  computed: {
    channelId: () => {
      return uuidv4();
    },

    isUploadDisabled() {
      return !this.image;
    },

    headers() {
      return {
        "X-CSRF-Token":
        document.querySelector("meta[name='csrf-token']")?.content
      };
    },

    nonSpecifiedCodes() {
      return this.codes.filter(item => item.tag === 'NOT_SPECIFIED')
    },

    workflowDetails() {
      return {
        physical: {
          type: 'physical',
          title: this.physicalFlowImageTitle,
          description: this.physicalFlowImageDescription,
          image: this.physicalFlowImage,
        },
        digital: {
          type: 'digital',
          title: this.digitalFlowImageTitle,
          description: this.digitalFlowImageDescription,
          image: this.digitalFlowImage,
        }
      }
    },
  },

  methods: {
    isFileSizeLimitOk(file) {
      return file && (file.size <= this.fileSizeLimit * 1024 * 1024);
    },

    goTo(step) {
      this.step = step;
    },

    goToBegin() {
      this.removeImage();
      this.goTo(1);
    },

    openModal(options) {
      const {isSumBased} = options;

      this.isSumBased = isSumBased;
      this.isOpen = true;

      this.initSSERequest(this.sseEndpoint);
    },

    closeModal() {
      this.removeImage();
      this.loading = false;
      this.step = 1;
      this.success = false;
      this.primaryCode = null;
      this.errorMessage = null;

      this.eventSource && this.eventSource.close();
      this.isOpen = false;
    },

    saveCodes() {
      const value = (this.isSumBased || this.codes.length === 1) ? this.codes : [this.primaryCode];

      this.$eventBus.$emit('codes:add', value);

      this.$nextTick(() => {
        this.closeModal();
      });
    },

    removeImage() {
      this.image = null;

      this.$nextTick(() => {
        // Reset the file input value
        if (this.$refs.uploadInput) {
          this.$refs.uploadInput.value = null;
        }
      });
    },

    onError(error) {
      this.success = false;
      this.errorMessage = error;
      this.step = 4;
    },

    onClickOnFile() {
      this.$refs.uploadInput.click();
    },

    uploadImage(event) {
      let file = event.target.files[0];
      event.target.value = null;

      if (!this.isFileSizeLimitOk(file)) {
        this.onError(this.maxSizeError);
      } else {
        this.reader.onloadend = () => {
          this.image = {
            name: file.name,
            url: URL.createObjectURL(file),
            file: file
          };
        };

        this.reader.onerror = () => {
          this.onError(this.readerError);
        };

        this.reader.readAsBinaryString(file);
      }
    },

    sendImage() {
      let fd = new FormData();
      const headers = {
        ...this.headers,
        "Content-Type": "multipart/form-data"
      };

      fd.append("file", this.image.file);
      fd.append("pattern", this.codePattern);
      fd.append('channel', this.channelId);

      this.loading = true;

      this.goTo(2);

      axios({
        method: "post",
        url: this.detectTextEndpoint,
        data: fd,
        headers: headers
      }).then(res => {
        const {message} = res.data;

        if (message) {
          this.onError(message);
        }
      }).catch((e) => {
        this.loading = false;
        this.onError(this.verifyCodesError);
      });
    },

    initSSERequest(endpoint) {
      const url = new URL(endpoint);
      url.searchParams.append('channel', this.channelId);
      this.eventSource = new EventSource(url.toString());

      this.eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        const {status, message, serial_numbers} = data;

        if (message && status !== Statuses.OK) {
          this.onError(message);
        }

        if (status === Statuses.OK && serial_numbers.length) {
          const uniques = uniq(serial_numbers);

          if (uniques.length) {
            this.defineWorkflow(uniques)
              .then(val => {
                this.codes = [];
                Object.entries(val).forEach(([key, value]) => {
                  this.codes.push({
                    value: key,
                    tag: value,
                  });
                });
                return this.codes;
              }).then(() => {
                if (this.nonSpecifiedCodes.length) {
                  this.goTo(3);
                } else {
                  this.success = true;
                  this.step = 4;
                }
            });
          }
        } else {
          this.loading = false;
        }
      };

      this.eventSource.onerror = (event) => {
        this.onError();
      };
    },

    defineWorkflow(codes) {
      this.loading = true;

      return axios({
        method: "post",
        url: this.workflowTypeDetectionEndpoint,
        data: {codes},
        headers: this.headers
      }).then((response) => {
        return response.data;
      })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        })
    },

    updateCodes(newCodes) {
      this.codes.forEach(code => {
        const updated = newCodes.find(item => item.value === code.value);
        if (updated) {
          code.tag = updated.tag;
        }
      });

      this.success = true;
      this.step = 4;
    }
  }
}
</script>
